import React, { useContext } from 'react';
import templateData from '../utility/getTemplateData';
import { Row, Col } from '@paypalcorp/pp-react';
import ConfirmationBody from './ConfirmationBody';
import ConfirmationTitle from './ConfirmationTitle';
import ConfirmationView from './ConfirmationView';
import PendingWarning from '../components/PendingWarning';
import PropTypes from 'prop-types';
import withConfirmationData from './withConfirmationData';
import withConfirmationMessages from './withConfirmationMessages';
import withTheme from '../components/withTheme';
import isNna from '../utility/nna';
import { MessageFormat } from '@paypalcorp/worldready';
import { Context as WorldReadyContext } from '@paypalcorp/worldready-react';

function PendingView(props) {
  const worldReady = useContext(WorldReadyContext);

  const bodyMessage = isNna(templateData.country)
    ? new MessageFormat(worldReady, {
        id: 'confirmation.pending.label.pendingNna',
      }).format()
    : new MessageFormat(worldReady, {
        id: 'confirmation.pending.label.pending2',
      }).format();

  const PendingMessage = () => (
    <>
      <Row>
        <Col xs={12} className="text-center">
          <ConfirmationTitle
            message={new MessageFormat(worldReady, {
              id: 'confirmation.pending.label.pending',
            }).format()}
          />
        </Col>
      </Row>
      <Row className="pending-content">
        <Col xs={12} className="text-center">
          <ConfirmationBody message={bodyMessage} />
        </Col>
      </Row>
    </>
  );

  return (
    <ConfirmationView
      {...props}
      illustration={<PendingWarning />}
      message={<PendingMessage />}
    />
  );
}

PendingView.propTypes = {
  handleRedirect: PropTypes.func,
  orgName: PropTypes.string,
  returnTo: PropTypes.string,
  returnTextMember: PropTypes.string,
};

export default withConfirmationData(
  withConfirmationMessages(withTheme(PendingView), 'pending')
);
